import s from 'string'

import sublevel from '@/services/SubLevelAdapterService'
import encrypt from '@/services/EncryptionService'
import ApplicationException from '@/errors/ApplicationException'

const module = {
  namespaced: true, // user/register
  state: () => ({
    user: {
      name: null,
      password: null
    },
    err: false
  }),
  getters: {
    users: (state, getters, rootState, rootGetters) => rootGetters.isConnected ? sublevel.sub(rootState.schema, 'users', { keyEncoding: 'utf8', valueEncoding: 'json' }) : null,
    hasErr: (state, getters, rootState, rootGetters) => (state.err !== false)
  },
  mutations: {
    REGISTER (state, name) {
      state.user.name = name
      state.user.password = null
      state.err = false
    },
    REGISTER_ERR (state, err) {
      state.err = err
    },
    RESET (state) {
      state.user.name = null
      state.user.password = null
      state.err = false
    }
  },
  actions: {
    async register ({ state, rootState, commit, dispatch, getters, rootGetters }, opts) {
      if (getters.isLoggedIn) return

      let users = getters.users
      let username = opts.username
      let password = opts.password

      try {
        // TODO: Validations could be moved elsewhere?
        if (s(username).isEmpty()) throw ApplicationException('Username is required', 'CredentialsInvalid')
        if (s(username).length < 5) throw ApplicationException('Username should be minimum 5 characters', 'CredentialsInvalid')
        if (s(username).length > 20) throw ApplicationException('Username should be maximum 20 characters', 'CredentialsInvalid')
        if (s(password).isEmpty()) throw ApplicationException('Password is required', 'CredentialsInvalid')
        if (s(password).length < 5) throw ApplicationException('Password should be minimum 5 characters', 'CredentialsInvalid')
        if (s(password).length > 20) throw ApplicationException('Password should be maximum 20 characters', 'CredentialsInvalid')

        await users.get(username)
        throw new ApplicationException('Username is already taken', 'AlreadyTaken')
      } catch (e) {
        switch (e.type) {
          case 'NotFoundError': // User does not exist; so can register
          case 'ReadError': // NODE_ENV=production seems to raise ReadError externally but NotFoundError on server side
            let { salt, hash: password } = encrypt.hash(opts.password)
            await users.put(username, { salt, password })

            commit('REGISTER', username)
            break
          case 'AlreadyTaken':
            commit('REGISTER_ERR', e.message)
            throw e
          default:
            commit('REGISTER_ERR', e.message)
            throw e
        }
      }
    },
    async reset ({ state, rootState, commit, dispatch, getters, rootGetters }, opts) {
      commit('RESET')
    }
  },
  modules: {}
}

export default module
